import { useEffect } from "react";
import PropTypes from "prop-types";
import { TbLayoutSidebarLeftCollapse } from "react-icons/tb";
import { useTheme } from "@mui/material/styles";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Drawer from "@mui/material/Drawer";
import Avatar from "@mui/material/Avatar";
import { alpha } from "@mui/material/styles";
import AccountPopover from './common/account-popover';

import { usePathname } from "../../../src/routes/hooks";

import { useResponsive } from "../../../src/hooks/use-responsive";

// import Logo from '../../../src/components/logo';
import Scrollbar from "../../../src/components/ui/scrollbar";

import { NAV } from "./config-layout";
import NavConfig from "./config-navigation";
import { useState } from "react";

// ----------------------------------------------------------------------

export default function Nav({ user, openNav, onCloseNav, handleLogout }) {
  const theme = useTheme();

  const pathname = usePathname();
  const upLg = useResponsive("up", "lg");

  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderAccount = (
    <Box
      sx={{
        my: 2,
        mx: collapsed ? "auto" : 2.5,
        py: 2,
        px: collapsed ? 0 : 2.5,
        display: "flex",
        borderRadius: 1.5,
        justifyContent: collapsed ? "center" : "inherit",
        alignItems: "center",
        bgcolor: collapsed
          ? "transparent"
          : (theme) => alpha(theme.palette.grey[500], 0.12),
      }}
    >
      <AccountPopover handleLogout={handleLogout} user={user} />

      {upLg ? (
        <>
          {" "}
          {!collapsed && (
            <Box sx={{ ml: 2 }}>
              <div className=" transform text-gray-700 font-semibold text-sm">
                {user && user.name}
              </div>

              <div className=" text-xs  text-gray-500 capitalize">
                {user && user?.puesto === "Trabajador Temporal" || "vendedor temporal" ? user?.subarea :  user?.puesto}
              </div>
            </Box>
          )}{" "}
        </>
      ) : (
        <Box sx={{ ml: 2 }}>
          <div className=" text-gray-700 font-semibold text-sm">
            {user && user.name}
          </div>

          <div className=" text-xs  text-gray-500 capitalize">
            {user && user?.puesto}
          </div>
        </Box>
      )}
    </Box>
  );

  const renderMenu = (
    <Stack
      component="nav"
      spacing={0.5}
      sx={{
        flexGrow: 1,          // Permite que el Stack crezca ocupando el espacio disponible
        overflowY: "auto",
        maxHeight: "calc(100vh - 180px)", // Ajusta según el tamaño de otros elementos
        px: 2,

        //display: "flex",       // Asegura que se comporte como un contenedor flexible
        //flexDirection: "column" // Mantiene la dirección de apilado de los elementos internos
      }}
    >
      <NavConfig upLg={upLg} collapsed={collapsed} user={user} />
    </Stack>
  );

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* <Logo sx={{ mt: 3, ml: 4 }} /> */}

      <div className={`flex ${ collapsed ? "justify-center" : "justify-between"} w-full mt-2 items-center mt-4 px-8`} >
        <img
          alt="logo"
          className={`object-contain w-10 h-10 ${collapsed ? "hidden" : ""}`}
          src="/images/sidebar-logo.webp"
        />
        <div
          className="bg-orange-500 bg-opacity-10 rounded-md p-3 cursor-pointer hover:bg-opacity-20 transition-all duration-200"
          onClick={() => setCollapsed(!collapsed)}
        >
          <TbLayoutSidebarLeftCollapse className=" text-orange-500" />
        </div>
      </div>

      {renderAccount}

      {renderMenu}

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: collapsed ? 60 : NAV.WIDTH },
        overflow: "hidden",
        zIndex: theme.zIndex.appBar + 2,

        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      }}
    >
      {upLg ? (
        <Box
          sx={{
            height: 1,
            position: "fixed",
            width: collapsed ? 60 : NAV.WIDTH,
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        >
          {renderContent}
        </Box>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.WIDTH,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

// ----------------------------------------------------------------------
